import microuniversoApi from "app/api/microuniversoApi"
import { atualizarClienteAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { ICliente } from "app/types/ICliente"
import { IOrcamento } from "app/types/IOrcamento"

export async function atualizarClientePendente(cliente: ICliente, senha?: string, senhaVendedorRelacionado?: string, senhaClienteComLimiteCreditoBloqueado?: string, validarCliente?: boolean) {
  const resposta = await microuniversoApi.Orcamento.atualizarCliente(store.getState().orcamento.IdentificadorOrcamento, cliente?.Codigo, senha, senhaVendedorRelacionado, senhaClienteComLimiteCreditoBloqueado, validarCliente)


  if (!("HasErrors" in resposta) || resposta.HasErrors == false) {

    store.dispatch(sobrescreverInformacoesAction(
        { ...store.getState().orcamento, 
            ValorTotal: (resposta as IOrcamento).ValorTotal, 
            ValorTotalMercadorias: (resposta as IOrcamento).ValorTotalMercadorias,
            ValorDesconto: (resposta as IOrcamento).ValorDesconto,
            ValorDescontoIcms: (resposta as IOrcamento).ValorDescontoIcms,//428915
            ValorAcrescimoFinanceiro: (resposta as IOrcamento).ValorAcrescimoFinanceiro,
            ValorCashbackUtilizado: (resposta as IOrcamento).ValorCashbackUtilizado,
            ValorDespesasInclusas: (resposta as IOrcamento).ValorDespesasInclusas,
            ValorFrete: (resposta as IOrcamento).ValorFrete,
            ValorDescontoIcmsDesonerado: (resposta as IOrcamento).ValorDescontoIcmsDesonerado, //428915
            CodigoFormaPagamento: (resposta as IOrcamento).CodigoFormaPagamento }))

    store.dispatch(atualizarClienteAction({
      Cliente: cliente,
      CodigoCliente: cliente?.Codigo,
      NomeCliente: cliente?.Nome
    }))
  }
  return resposta
}
